import { FormLabel, FormSelect } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";

const LinkTargetEditor = (props: IFieldEditor) => {

  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) : void => {
    const value = event.target.value;
    props.onValueChange(props.property.Id, value);
  };

  return (
    <>
      <FormLabel htmlFor={`selectTarget-${props.property.Id}`}>{props.property.DisplayLabel}</FormLabel>
      <FormSelect 
        id={`selectTarget-${props.property.Id}`}
        name={`selectTarget-${props.property.Id}`}
        value={props.property.PublishedValue || props.property.DefaultValue || ""}
        title="select link target"
        onChange={selectChange}>
          <option value="">Select link target...</option>
          <option value="_blank">new tab</option>
          <option value="_self">same tab</option>
          <option value="_parent">parent frameset</option>
          <option value="_top">full body of window</option>
      </FormSelect>
    </>
  );
}

export default LinkTargetEditor;